export default {
  detectContext() {
    const ua = navigator.userAgent

    const isIOS = /iPhone|iPad|iPod/i.test(ua)
    const isAndroid = /Android/i.test(ua)

    const isLine = /Line/i.test(ua)
    const isFacebook = /FBAN|FBAV/i.test(ua)
    const isInstagram = /Instagram/i.test(ua)
    const isWebView = /(wv|WebView)/i.test(ua)

    const isInApp =
      isLine ||
      isFacebook ||
      isInstagram ||
      isWebView

    return {
      isIOS,
      isAndroid,
      isLine,
      isFacebook,
      isInstagram,
      isInApp
    }
  },
  isFacebookInApp() {
    return /FBAN|FBAV/i.test(navigator.userAgent)
  },

  isLineInApp() {
    return /Line/i.test(navigator.userAgent)
  },
  isIOS() {
    return (
      /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    )
  },
  isInApp() {
    return /Line|FBAN|FBAV|Instagram|TikTok/i.test(navigator.userAgent)
  },
  detectOS() {
    const ua = navigator.userAgent

    if (/iPhone|iPad|iPod/i.test(ua)) {
      return 'iOS'
    }

    if (/Android/i.test(ua)) {
      return 'Android'
    }

    return 'Other'
  },
  isRealSafari() {
    const ua = navigator.userAgent
    return /Safari/i.test(ua) && !/CriOS|FxiOS|Line|FBAN|FBAV/i.test(ua)
  },
  isInAppBrowser() {
    const ua = navigator.userAgent
    return /Line|FBAN|FBAV|Instagram|TikTok/i.test(ua)
  },
  detectOpenFrom() {
    const ua = navigator.userAgent

    if (window.liff) {
      return 'LINE (LIFF)'
    }

    if (/Line/i.test(ua)) {
      return 'LINE In-App Browser'
    }

    if (/FBAN|FBAV/i.test(ua)) {
      return 'Facebook In-App Browser'
    }

    if (/Instagram/i.test(ua)) {
      return 'Instagram In-App Browser'
    }

    if (/TikTok/i.test(ua)) {
      return 'TikTok In-App Browser'
    }

    if (/iPhone|iPad|iPod/i.test(ua)) {
      if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) {
        return 'Safari (iOS)'
      }
      if (/CriOS/i.test(ua)) {
        return 'Chrome (iOS)'
      }
    }

    if (/Android/i.test(ua)) {
      if (/Chrome/i.test(ua)) {
        return 'Chrome (Android)'
      }
      return 'Android In-App Browser'
    }

    return 'Unknown'
  },
  redirectToExternalBrowser() {
    const url = window.location.href
    const ua = navigator.userAgent

    const isIOS = /iPhone|iPad|iPod/i.test(ua)
    const isAndroid = /Android/i.test(ua)
    const isFacebook = /FBAN|FBAV/i.test(ua)
    const isLine = /Line/i.test(ua)

    // ===== iOS Facebook =====
    if (isIOS && isFacebook) {
      // ❌ บังคับไม่ได้ → ต้อง guide เท่านั้น
      this.showIOSGuide = true
      return
    }

    // ===== iOS LINE =====
    if (isIOS && isLine && window.liff) {
      liff.openWindow({
        url,
        external: true
      })
      return
    }

    // ===== Android =====
    if (isAndroid) {
      const intentUrl =
        `intent://${url.replace(/^https?:\/\//, '')}` +
        `#Intent;scheme=https;package=com.android.chrome;end`

      window.location.href = intentUrl
      return
    }

    // ===== Desktop =====
    window.open(url, '_blank')
  },
  detectInAppBrowser() {
    const ua = navigator.userAgent || navigator.vendor || window.opera

    return {
      isLine: /Line/i.test(ua),
      isFacebook: /FBAN|FBAV/i.test(ua),
      isInstagram: /Instagram/i.test(ua),
      isMessenger: /Messenger/i.test(ua),
      isTikTok: /TikTok/i.test(ua),
      isInApp: /Line|FBAN|FBAV|Instagram|Messenger|TikTok/i.test(ua),
      isIOS: /iPhone|iPad|iPod/i.test(ua),
      isAndroid: /Android/i.test(ua)
    }
  },
  getFilteredPaymentMethods(shop, orderShopSetting, allPaymentMethods) {
    const ghlConfig = shop?.GHLMethodEnabled || {};
    const ghlEnabled = ghlConfig.enabled === true;
    const kbankEnabled = shop?.enabledKPaymentGateway === true;
    const selectedGateway = orderShopSetting?.selectedGateway;
  
    const kbankMethods = [
      { id: "qr", name: "QRCode", icon: "qrIcon.webp", iconHeader: "thaiqr_banner.webp", bgColor: "#113566", type: "qr" },
      // { id: "credit", name: "creditCard", icon: "masterCardIcon.webp", iconHeader: "credit_.webp", bgColor: "#f5f5f5", type: "credit" },
    ];
  
    const ghlMethods = Array.isArray(ghlConfig.methods)
      ? allPaymentMethods.filter(method => ghlConfig.methods.includes(method.type))
      : [];
  
    if (kbankEnabled && ghlEnabled) {
      return selectedGateway === 'KBANK' ? kbankMethods : ghlMethods;
    }
  
    if (kbankEnabled) return kbankMethods;
    if (ghlEnabled) return ghlMethods;
  
    return [];
  },
  convertTime(input) {
    let date;
    if (input.includes('T')) {
      date = new Date(input);
    } else {
      date = new Date(parseInt(input));
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
  },
  createObjectId() {
    let timestamp = ((new Date().getTime() / 1000) | 0).toString(16)
    return (
      timestamp +
      'xxxxxxxxxxxxxxxx'
        .replace(/[x]/g, function () {
          return ((Math.random() * 16) | 0).toString(16)
        })
        .toLowerCase()
    )
  },

  currencyStringToNumber(currency) {
    return Number(currency.replace(/[^0-9\.-]+/g, ''))
  },

  convertCurrency(currency) {
    return currency.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  },

  convertNumber(text) {
    return text.toLocaleString(undefined, { maximumFractionDigits: 2 })
  },

  compare(a, b) {
    if (a.name < b.name) return -1
    if (a.name > b.name) return 1
    return 0
  },

  generateVoucherCode() {
    let chars = '1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
    let serialLength = 8

    return Array.from(crypto.getRandomValues(new Uint32Array(serialLength)))
      .map((x) => chars[x % chars.length])
      .join('')
  },

  generateSerialNumber() {
    let len = 10
    let wishlist = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'

    return Array.from(crypto.getRandomValues(new Uint32Array(len)))
      .map((x) => wishlist[x % wishlist.length])
      .join('')
  },

  generateNumber() {
    let chars = '1234567890'
    let serialLength = 7

    return Array.from(crypto.getRandomValues(new Uint32Array(serialLength)))
      .map((x) => chars[x % chars.length])
      .join('')
  },

  getImageURL(url, size) {
    let domain = 'https://storage.googleapis.com/';

    // Check if the URL does not start with the expected domain
    if (url && !url.startsWith('https://firebasestorage')) {
      return url; // Return the original URL
    }

    // Format url
    let convertedUrl = decodeURIComponent(url);

    // Clean path
    let imagePath = convertedUrl.substring(convertedUrl.indexOf('/b/')).split('?')[0];

    // Clean file type
    let fileType = imagePath.substring(imagePath.lastIndexOf('.') + 1);
    imagePath = imagePath.replace('.' + fileType, "").replace("/b/", "").replace('/o', "");

    return domain + imagePath + '_' + size + 'x' + size + '.webp';
  },


  generateColor(indexColor) {
    switch (indexColor) {
      case 0:
        return 'rgba(250, 80, 64, 1)'
      case 1:
        return 'rgba(41, 178, 137, 1)'
      case 2:
        return 'rgba(84, 0, 116, 1)'
      case 3:
        return 'rgba(224, 111, 78, 1)'
      case 4:
        return 'rgba(179, 169, 175, 1)'
      case 5:
        return 'rgba(240, 166, 214, 1)'
      case 6:
        return 'rgba(206, 11, 44, 1)'
      case 7:
        return 'rgba(117, 50, 67, 1)'
      case 8:
        return 'rgba(244, 180, 0, 1)'
      case 9:
        return 'rgba(41, 180, 107, 1)'
      case 10:
        return 'rgba(163, 115, 97, 1)'
      case 11:
        return 'rgba(244, 175, 90, 1)'
      case 12:
        return 'rgba(109, 204, 147, 1)'
      case 13:
        return 'rgba(77, 164, 107, 1)'
      case 14:
        return 'rgba(144, 206, 93, 1)'
      case 15:
        return 'rgba(188, 218, 122, 1)'
      case 16:
        return 'rgba(249, 232, 145, 1)'
      case 17:
        return 'rgba(224, 209, 118, 1)'
      case 18:
        return 'rgba(163, 222, 194, 1)'
      case 19:
        return 'rgba(172, 223, 230, 1)'
      case 20:
        return 'rgba(166, 197, 228, 1)'
      case 21:
        return 'rgba(85, 135, 224, 1)'
      case 22:
        return 'rgba(153, 158, 248, 1)'
      case 23:
        return 'rgba(179, 157, 248, 1)'
      case 24:
        return 'rgba(143, 143, 143, 1)'
      case 25:
        return 'rgba(200, 189, 191, 1)'
      case 26:
        return 'rgba(198, 168, 170, 1)'
      case 27:
        return 'rgba(233, 150, 177, 1)'
      case 28:
        return 'rgba(193, 123, 224, 1)'
      case 29:
        return 'rgba(157, 126, 220, 1)'
      default:
        return 'rgba(41, 178, 137, 1)'
    }
  },
  groupOptionItemsByGroup(optionItems) {
    const groupedOptions = {};

    optionItems.forEach(item => {
      const groupId = item.optionGroup.id;

      if (!groupedOptions[groupId]) {
        groupedOptions[groupId] = {
          name: item.optionGroup.name,
          ...(item.optionGroup.nameTranslation && { nameTranslation: item.optionGroup.nameTranslation }),
          id: item.optionGroup.id,
          objectId: item.optionGroup.objectId,
          orderIndex: item.optionGroup.orderIndex || 0, // Default to 0 if orderIndex is missing
          items: []
        };
      }

      groupedOptions[groupId].items.push({
        optionItemName: item.optionItemName,
        ...((item.optionItem.nameTranslation || item.nameTranslation) && { nameTranslation: item.optionItem.nameTranslation || item.nameTranslation }),
        id: item.optionItem.id,
        objectId: item.optionItem.objectId,
        name: item.optionItem.name,
        quantity: item.quantity || 1,  // Default to 1 if quantity is missing
        price: item.price || 0,  // Default to 0 if price is missing
        orderIndex: item.optionItem.orderIndex || 0  // Default to 0 if orderIndex is missing
      });
    });

    // Convert to array and sort option groups by orderIndex
    const sortedGroups = Object.values(groupedOptions).sort((a, b) => a.orderIndex - b.orderIndex);

    // Sort items within each group by orderIndex
    sortedGroups.forEach(group => {
      group.items.sort((a, b) => a.orderIndex - b.orderIndex);
    });

    return sortedGroups;
  },


  getGHLPaymentMethods() {
    return [
      { id: "cash", name: "paymentType0", icon: "cashIcon.webp", bgColor: "#f5f5f5", type: 'cash' },
      { id: "qr", name: "QRCode", icon: "qrIcon.webp", iconHeader: "thaiqr_banner.webp", bgColor: "#113566", type: 'T' },
      // { id: "qrBBL", name: "QRCodeBBL", icon: "masterCardIcon.webp", iconHeader: "credit_.webp", bgColor: "#f5f5f5", type: '5' },
      { id: "truewallet", name: "TrueMoney Wallet", icon: "trueWalletIcon.webp", iconHeader: "trueWallet_.webp", bgColor: "#f5f5f5", type: '4' },
      { id: "alipay", name: "Alipay", icon: "aliPayIcon.webp", iconHeader: "aliPay_.webp", bgColor: "#1677ff", type: 'X' },
      { id: "rabbitpay", name: "Rabbit LINE Pay", icon: "rabbitPayIcon.webp", iconHeader: "rabbit_.webp", bgColor: "#09bf5b", type: 'L' },
      { id: "wechat", name: "WeChat Pay", icon: "weChatIcon.webp", iconHeader: "weChat_.webp", bgColor: "#f5f5f5", type: '6' },
      { id: "credit", name: "creditCard", icon: "masterCardIcon.webp", iconHeader: "masterCard_.webp", bgColor: "#f5f5f5", type: 'credit' },
      // { id: "mastercard", name: "MasterCard", icon: "masterCardIcon.webp", iconHeader: "masterCard_.webp", bgColor: "#f5f5f5" },
      { id: "shopeepay", name: "ShopeePay", icon: "shoppeePayIcon.webp", iconHeader: "shoppeePay_.webp", bgColor: "#ed4c2f" },
      { id: "sabuy", name: "Sabuy Money", icon: "sabuyIcon.webp", iconHeader: "sabuy_.webp", bgColor: "#f5f5f5" },
      { id: "atome", name: "Atome", icon: "atomIcon.webp", iconHeader: "atom_.webp", bgColor: "#f0ff5f", type: 'B' }
    ]
  },
  getKbankPaymentMethods() {
    return [
      { id: "cash", name: "paymentType0", icon: "cashIcon.webp", bgColor: "#f5f5f5", type: 'cash' },
      { id: "qr", name: "QRCode", icon: "qrIcon.webp", iconHeader: "thaiqr_banner.webp", bgColor: "#113566", type: 'qr' },
      // { id: "qrBBL", name: "QRCodeBBL", icon: "masterCardIcon.webp", iconHeader: "credit_.webp", bgColor: "#f5f5f5", type: '5' },
      { id: "truewallet", name: "TrueMoney Wallet", icon: "trueWalletIcon.webp", iconHeader: "trueWallet_.webp", bgColor: "#f5f5f5", type: '4' },
      { id: "alipay", name: "Alipay", icon: "aliPayIcon.webp", iconHeader: "aliPay_.webp", bgColor: "#1677ff", type: 'X' },
      { id: "rabbitpay", name: "Rabbit LINE Pay", icon: "rabbitPayIcon.webp", iconHeader: "rabbit_.webp", bgColor: "#09bf5b", type: 'L' },
      { id: "wechat", name: "WeChat Pay", icon: "weChatIcon.webp", iconHeader: "weChat_.webp", bgColor: "#f5f5f5", type: '6' },
      { id: "creditcard", name: "creditCard", icon: "masterCardIcon.webp", iconHeader: "masterCard_.webp", bgColor: "#f5f5f5", type: 'creditcard' },
      { id: "credit", name: "creditCard", icon: "masterCardIcon.webp", iconHeader: "masterCard_.webp", bgColor: "#f5f5f5", type: 'credit' },

      // { id: "mastercard", name: "MasterCard", icon: "masterCardIcon.webp", iconHeader: "masterCard_.webp", bgColor: "#f5f5f5" },
      { id: "shopeepay", name: "ShopeePay", icon: "shoppeePayIcon.webp", iconHeader: "shoppeePay_.webp", bgColor: "#ed4c2f" },
      { id: "sabuy", name: "Sabuy Money", icon: "sabuyIcon.webp", iconHeader: "sabuy_.webp", bgColor: "#f5f5f5" },
      { id: "atome", name: "Atome", icon: "atomIcon.webp", iconHeader: "atom_.webp", bgColor: "#f0ff5f", type: 'B' }
    ]
  },

  getGHLMethodNameByType(type) {
    const method = this.getGHLPaymentMethods().find(m => m.type === type)
    return method ? method.name : null
  },
  getKbankMethodNameByType(type){
    const method = this.getKbankPaymentMethods().find(m => m.type === type)
    return method ? method.name : null
  }
}
